import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarProductosConfiguracion } from '../../../actions/configuracion';

const EliminarProductos = ({ productos, reestablecerProductos }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar producto */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarProductosConfiguracion(productos));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerProductos([]);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(productos?.length > 0){
            setEliminarModal(true);
        }
    }, [productos]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar productos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar {productos?.length} producto{productos?.length == 1 ? '' : 's'}?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarProductos;